module.exports = __webpack_public_path__ + "img/UTYUBA.4508d7e2.png";